/* eslint-disable */
import AgoraRTC from "agora-rtc-sdk-ng";
import { Message } from 'element-ui'
import Bus from '@/assets/js/bus.js';
import $Store from '@/store/index.js'
import protoRoot from '@/assets/js/SttMessage_es6.js'
import { handleLocalStorage } from '@/assets/js/utils.js'

window.partyLine = AgoraRTC;
AgoraRTC.setLogLevel(2)
// AgoraRTC.enableLogUpload()
export default class RTCClient {
  constructor(callBack) {
    this._client = null;
    this._callBack = callBack;
    this._params = {};
    this._localAudioTrack = null
    this._localVideoTrack = null
    this._customVideoTrack = null //为了镜像添加的参数
    this._AgoraRTC = AgoraRTC
    this._shareTrack = null
    this._publishVideo = false //当前video是否是发流状态
    this._publishAudio = false //当前audio是否是发流状态
    this._hasPublishVideo = false //是否存在发过video
    this._hasPublishAudio = false //是否存在发过audio
    this._remotePublishUser = {}
    this._subscribeTrack = {}
    this._deviceInfo = {}
    this._role = 'audience'
    this.networksInterval = null
    this.playTimer = null
    this.hasJoined = false
    this.connectStatus = 'CONNECTING'
    // 添加监听自动播放失败函数
    this.listenIsAutoplayFailed()
    this.listenCameraChange()
    this.listenMicChange()
    this.listenPlaybackChange()
  }
  listenIsAutoplayFailed () {
    AgoraRTC.onAutoplayFailed = () => {
      this._callBack && this._callBack({
        action: 'autoPlayFailed',
        payload: {
          id: this._params.uid,
          channel: this._params.channel
        }
      })
    }
  }
  listenCameraChange () {
    AgoraRTC.onCameraChanged = (changeDevice) => {
      this._callBack && this._callBack({
        action: 'cameraChange',
        payload: {
          id: this._params.uid,
          channel: this._params.channel,
          changeDevice
        }
      })
    }
  }
  listenMicChange () {
    AgoraRTC.onMicrophoneChanged = (changeDevice) => {
      this._callBack && this._callBack({
        action: 'micChange',
        payload: {
          id: this._params.uid,
          channel: this._params.channel,
          changeDevice
        }
      })
    }
  }
  listenPlaybackChange () {
    AgoraRTC.onPlaybackDeviceChanged = (changeDevice) => {
      this._callBack && this._callBack({
        action: 'playbackChange',
        payload: {
          id: this._params.uid,
          channel: this._params.channel,
          changeDevice
        }
      })
    }
  }
  rePlay () {
    if (this._params.isPlay !== false && this._localVideoTrack) {
      this._localVideoTrack.play(`${this._params.domId || 'local_stream'}`, {
        mirror: true
      })
      this.setSolution()
    }
  }

  async getDevice () {
    let obj = {
      cameraList: [],
      microphoneList: [],
      speakerList: [],
      microphoneId: '',
      cameraId: '',
      cameraError: '',
      microphoneError: '',
      speakerId: ''
    }
    let cameraDevice = []
    let microphoneDevice = []
    let speakerDevice = []
    let microphoneId = handleLocalStorage('get', 'microphoneId')
    let cameraId = handleLocalStorage('get', 'cameraId')
    let speakerId = handleLocalStorage('get', 'speakerId')
    try {
      await AgoraRTC.getCameras().then(res => {
        cameraDevice = res
        if (cameraDevice.length > 0) {
          cameraDevice.forEach((item, index) => {
            if (item.kind === 'videoinput' && item.deviceId !== "") {
              obj.cameraList.push(item)
              if (cameraId == item.deviceId) {
                obj.cameraId = cameraId
              }
            }
          })
        }
      }).catch((error) => {
        obj.cameraError = error.code
        console.info('getCameras error', error.code)
      })
      await AgoraRTC.getPlaybackDevices()
        .then((res) => {
          speakerDevice = res
          if (speakerDevice.length > 0) {
            speakerDevice.forEach((item, index) => {
              if (item.kind === 'audiooutput' && item.deviceId !== '') {
                if (speakerId == item.deviceId) {
                  obj.speakerId = speakerId
                }
                obj.speakerList.push(item)
              }
            })
          }
        })
        .catch(() => {
          console.info('getSpeakers error')
        })

      await AgoraRTC.getMicrophones().then(res => {
        microphoneDevice = res
        if (microphoneDevice.length > 0) {
          microphoneDevice.forEach((item, index) => {
            if (item.kind === 'audioinput' && item.deviceId !== "") {
              if (microphoneId == item.deviceId) {
                obj.microphoneId = microphoneId
              }
              obj.microphoneList.push(item)
            }
          })
        }
      }).catch((error) => {
        console.info('getMicrophones error', error.code)
        obj.microphoneError = error.code
      })
      if (!obj.cameraId) {
        obj.cameraId = obj.cameraList[0] ? obj.cameraList[0].deviceId : ''
        handleLocalStorage('set', 'cameraId', obj.cameraId)
      }
      if (!obj.microphoneId) {
        obj.microphoneId = obj.microphoneList[0] ? obj.microphoneList[0].deviceId : ''
        handleLocalStorage('set', 'microphoneId', obj.microphoneId)
      }
      if (!obj.speakerId) {
        obj.speakerId = obj.speakerList[0] ? obj.speakerList[0].deviceId : ''
        handleLocalStorage('set', 'speakerId', obj.speakerId)
      }
      this._deviceInfo = obj
      return obj

    } catch (e) {
      Message({
        message: e.message,
        type: 'error',
        offset: 50,
        showClose: true
      })
      console.info('getdevices failed', e)
      return obj
    }
  }
  async setDevice (deviceId, type, fn, localTrack, hostControl) {
    if (type === 'video') {
      $Store.state.initCamera = true
      $Store.state.showInitCameraTips = false
    }

    if (type == 'video' && !this._localVideoTrack) {
      const videoConfig = this._params.videoConfig || [{
        width: 640,
        height: 360,
        fps: 15,
        bitrate: 500
      }]
      this._localVideoTrack = await AgoraRTC.createCameraVideoTrack({
        cameraId: deviceId, //指定摄像头
        encoderConfig: {
          // 视频分辨率
          width: videoConfig[0].width,
          height: videoConfig[0].height,
          // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
          frameRate: {
            min: 15,
            max: videoConfig[0].fps
          },
          bitrateMin: videoConfig[0].bitrate,
          bitrateMax: videoConfig[0].bitrate
        }
      })
      $Store.state.initCamera = false
      if (this._localVideoTrack && this._client) {
        this._localVideoTrack.play(`${this._params.domId || 'local_stream'}`, {
          mirror: true
        })
        if (!this._hasPublishVideo && this._params.publish !== false && this._client) {
          if (this._role !== 'host' && this._client) {
            await this._client.setClientRole('host') //不需要推流的不用设置host
            this._role = 'host'
          }
          let trackArray = [this._localVideoTrack]
          this._client && this.hasJoined && this._client.publish(trackArray)
        }
        if (hostControl) $Store.state.anAvailbleDeviceId = ''
      } else {
        $Store.state.showInitCameraTips = true
        this._deviceInfo && this._deviceInfo.cameraList?.forEach(item => {
          if (item.deviceId == deviceId) {
            $Store.state.cameraName = item.label
          }
        })
      }
    }
    if (type == 'video' && (this._localVideoTrack || localTrack)) {
      const track = this._localVideoTrack || localTrack
      track.setDevice(deviceId).then(() => {
        if (hostControl) $Store.state.anAvailbleDeviceId = ''
        $Store.state.initCamera = false
        handleLocalStorage('set', 'cameraId', deviceId)
        this.setSolution('', localTrack)
        this._localVideoTrack && this._localVideoTrack.setEnabled(true)
        localTrack && localTrack.setEnabled(true)
        $Store.state.showInitCameraTips = false
        if (fn) fn('success')
      }).catch((e) => {
        if (hostControl) $Store.state.anAvailbleDeviceId = deviceId
        $Store.state.initCamera = false
        $Store.state.showInitCameraTips = true
        this._deviceInfo && this._deviceInfo.cameraList?.forEach(item => {
          if (item.deviceId == deviceId) {
            $Store.state.cameraName = item.label
          }
        })
        if (fn) fn('failed')
        this._localVideoTrack && this._localVideoTrack.setEnabled(false)
        localTrack && localTrack.setEnabled(false)
      })
    }
    if (type == 'audio' && (this._localAudioTrack || localTrack)) {
      console.log('log:', `switch to ${deviceId} device`)
      const track = this._localAudioTrack || localTrack
      track.setDevice(deviceId).then(() => {
        handleLocalStorage('set', 'microphoneId', deviceId)
        if (fn) fn('success')
      }).catch(() => {
        if (fn) fn('failed')
      })
    }
  }
  async join (data) {
    this._params = data
    this._params.publishAudio = this._params.publishAudio !== false
    this._params.publishVideo = this._params.publishVideo !== false
    let { mode, codec, token, appId, channel, uid, share, getRemoteNetworks, startProxy, status } = data
    // 创建本地客户端
    // mode: live直播场景 rtc通信场景
    this._client = AgoraRTC.createClient({ mode: mode || "live", codec: codec || "vp8" });
    if (startProxy) {
      this._client.startProxyServer(3)
    }
    // 添加监听事件
    if (!share) {
      this.addEventsListener()
    }
    // join channel
    try {
      let result, hasShare
      // 创建并播放
      if (share && this._client) {
        if (!$Store.state.isSafari) {
          result = await this._client.join(appId, channel, token, uid)
          this.hasJoined = true
          console.info("join success", uid, channel);
          hasShare = await this.createShareTrack(status)
        } else {
          this._client.join(appId, channel, token, uid)
          await Promise.all([
            AgoraRTC.createScreenVideoTrack({
              encoderConfig: '1080p_3',
            }, 'auto').then(async (localScreenTrack) => {
              const isArray = Array.isArray(localScreenTrack)
              this._shareTrack = localScreenTrack
              this.shareEventListener()
              await this._client?.setClientRole("host") //不需要推流的不用设置host
              this._role = 'host'
              this.hasJoined && this._client?.publish(localScreenTrack)
              this._callBack && this._callBack({
                action: 'start-share',
                payload: {
                  id: this._params.uid,
                  channel: this._params.channel,
                  shareInfo: {
                    videoTrack: isArray ? localScreenTrack[0] : localScreenTrack,
                    audioTrack: isArray ? localScreenTrack[1] : null
                  }
                }
              })
            }).catch((error) => {
              const { code } = error
              // 错误码与消息的映射表
              const errorMessageMap = {
                NOT_SUPPORTED: 'Not supported on the current browser.',
                MEDIA_OPTION_INVALID: 'The device does not support the specified resolution or frame rate.',
                DEVICE_NOT_FOUND: 'The specified capture device cannot be found.',
                CONSTRAINT_NOT_SATISFIED: 'The browser does not support the specified capture options.',
                SHARE_AUDIO_NOT_ALLOWED: 'The user did not check the option to share audio while sharing the screen.',
                // PERMISSION_DENIED: 'Create screen share permission denied.'
              }
              // 获取消息内容，未匹配时使用默认值
              const message = errorMessageMap[code] || 'Failed to create local audio and video objects.'
              // 统一显示错误消息
              Message({
                message,
                type: 'error',
                offset: 50,
                showClose: true
              })
              this._client.leave()
              this._callBack && this._callBack({
                action: 'stop-share',
                payload: {
                  id: this._params.uid,
                  channel: this._params.channel,
                  type: 'Safari-CreateScreenFailed'
                }
              })
            })
          ])
        }
      } else {
        result = await this._client.join(appId, channel, token, uid)
        this.hasJoined = true
        console.info("join success", uid, channel, result);
        await this.createLocalTrack()
      }
      // 是否获取远端的client的网络状态
      if (getRemoteNetworks) {
        this.getRemoteNetworksFn()
      }
      if (share) {
        if (hasShare) {
          return result
        } else {
          return ''
        }
      } else {
        return result
      }
    } catch (e) {
      console.info("join failed", e, channel, uid);
    }
  }
  async createLocalTrack () {
    try {
      let {
        audio,
        video,
        microphoneId,
        cameraId,
        videoConfig,
        domId,
        isPlay,
        publish,
        publishAudio,
        publishVideo,
      } = this._params
      if (audio !== false) { //默认创建本地音频流
        try {
          this._localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
            AEC: handleLocalStorage('get', 'checkedAec') ? JSON.parse(handleLocalStorage('get', 'checkedAec')) : true, //回声消除
            ANS: handleLocalStorage('get', 'checkedAns') ? JSON.parse(handleLocalStorage('get', 'checkedAns')) : true, //噪声抑制
            AGC: handleLocalStorage('get', 'checkedAgc') ? JSON.parse(handleLocalStorage('get', 'checkedAgc')) : true,  //麦克风增强
            microphoneId, //指定麦克风
            encoderConfig: handleLocalStorage('get', 'audioQualityPreset') || 'high_quality'
          })
        } catch (e) {
          console.info('create local audio error', e)
          // 创建流失败，则就不会发流
          this._callBack && this._callBack({
            action: 'local-unpublish',
            payload: {
              id: this._params.uid,
              type: ['audio']
            }
          })
        }
      }

      if (video !== false && (!videoConfig || !videoConfig.length)) return
      if (video !== false) { //默认创建本地音频流
        // let userCameraId = cameraId
        try {
          $Store.state.initCamera = true
          this._localVideoTrack = await AgoraRTC.createCameraVideoTrack({
            cameraId, //指定摄像头
            encoderConfig: {
              // 视频分辨率
              width: videoConfig[0].width,
              height: videoConfig[0].height,
              // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
              frameRate: {
                min: 15,
                max: videoConfig[0].fps
              },
              bitrateMin: videoConfig[0].bitrate,
              bitrateMax: videoConfig[0].bitrate
            }
          })
          if (this._localVideoTrack) $Store.state.initCamera = false
        } catch (e) {
          // 创建流失败，则就不会发流
          $Store.state.initCamera = false
          $Store.state.showInitCameraTips = true
          this._deviceInfo && this._deviceInfo.cameraList && this._deviceInfo.cameraList.forEach(item => {
            if (item.deviceId == cameraId) {
              $Store.state.cameraName = item.label
            }
          })
          // }
        }
      }

      //只播放本地视频即可，无需播放音频
      if (isPlay !== false && this._localVideoTrack) {
        if (document.getElementById(`${domId || 'local_stream'}`)) {
          this._localVideoTrack.play(`${domId || 'local_stream'}`, {
            mirror: true
          })
        } else {
          const _this = this
          if (this.playTimer) clearInterval(this.playTimer)
          this.playTimer = setInterval(() => {
            if (document.getElementById(`${domId || 'local_stream'}`)) {
              _this._localVideoTrack && _this._localVideoTrack.play(`${domId || 'local_stream'}`, {
                mirror: true
              })
              if (this.playTimer) clearInterval(this.playTimer)
            }
          }, 100);
        }
        this.setSolution()
      }
      this._callBack && this._callBack({
        action: 'local-track',
        payload: {
          id: this._params.uid,
          audioTrack: this._localAudioTrack,
          videoTrack: this._localVideoTrack
        }
      })
      // 推流
      if (publish !== false && this._client) {
        //直播场景里，调用 setClientRole 将用户角色设为主播后才能publish
        await this._client?.setClientRole("host").catch((e) => {
          const data = e.data
          if (data.code === 2031) {
            Message.warning('The number of anchors has reached the upper limit, and you have been automatically downgraded to an audience. Viewers are not allowed to stream')
            return
          }
        })
        //不需要推流的不用设置host
        this._role = 'host'

        // 确认需要publish的流
        let trackArray = []
        if (this._localAudioTrack && publishAudio) {
          trackArray.push('audio')
        }
        if (this._localVideoTrack && publishVideo) {
          trackArray.push('video')
        }
        this.hasJoined && this.publish(trackArray)
      }
    } catch (e) {
      console.info('creat track failed')
    }
  }
  async publish (array, fn) {
    if (!this.hasJoined) return
    try {
      let trackArray = []
      //直播场景里，调用 setClientRole 将用户角色设为主播后才能publish
      if (this._role !== 'host' && this._client) {
        await this._client.setClientRole("host") //不需要推流的不用设置host
        this._role = 'host'
      }
      if (array && array.length && this._client) {
        console.info('publish', this._params.channel)
        array.forEach(async val => {
          if (val == 'audio' && this._localAudioTrack && !this._publishAudio) {
            // 为了 conference 添加的
            if (!this._localAudioTrack._enabled) {
              await this._localAudioTrack.setEnabled(true)
            }
            trackArray.push(this._localAudioTrack)
            console.info('publish audio', this._params.channel)
          }
          if (val == 'video' && this._localVideoTrack && !this._publishVideo) {
            if (!this._localVideoTrack._enabled) {
              await this._localVideoTrack.setEnabled(true)
            }
            trackArray.push(this._localVideoTrack)
            console.info('publish video', this._params.channel)
          }
        })
        if (!trackArray.length) return
        await this._client?.publish(trackArray);
        // const transceiver = this._localVideoTrack?.getRTCRtpTransceiver()
        // if (!transceiver || !transceiver.sender) {
        //   return
        // }
        // const sender = transceiver.sender
        // const streams = sender.createEncodedStreams()
        // const transformer = new TransformStream({
        //   transform: (chunk, controller) => {
        //     controller.enqueue(chunk)
        //   }
        // })
        // streams.readable.pipeThrough(transformer).pipeTo(streams.writable)
        if (array.includes('audio')) {
          this._hasPublishAudio = true
          this._publishAudio = true
        }
        if (array.includes('video')) {
          this._hasPublishVideo = true
          this._publishVideo = true
        }
        console.info('publish success', this._params.uid, this._params.channel);
        this._callBack && this._callBack({
          action: 'local-publish',
          payload: {
            id: this._params.uid,
            type: array
          }
        })
      }
    } catch (e) {
      if (fn) fn({ type: 'failed' })
      console.info('publish failed', e)
    }
  }
  async unpublish (array) {
    // trackArray可以是单个视频或音频流也可是是数组集合的形式
    try {
      let trackArray = []
      if (array.length) {
        console.info('unpublish', this._params.channel)
        array.forEach(val => {
          if (val == 'audio' && this._localAudioTrack && this._publishAudio) {
            trackArray.push(this._localAudioTrack)
          }
          if (val == 'video' && this._localVideoTrack && this._publishVideo) {
            trackArray.push(this._localVideoTrack)
          }
        })
        await this._client.unpublish(trackArray);
        if (array.includes('audio')) {
          this._publishAudio = false
          this._hasPublishAudio = false
        }
        if (array.includes('video')) {
          this._publishVideo = false
          this._hasPublishVideo = false
        }
        this._role = 'audience'
        console.info('unpublish success')
        this._callBack && this._callBack({
          action: 'local-unpublish',
          payload: {
            id: this._params.uid,
            type: array
          }
        })
      }
    } catch (e) {
      console.info('unpublish failed', e)
    }
  }
  setSolution (width, localTrack) {
    const constraints = {
      aspectRatio: {
        exact: 640 / 360
      }
    };
    const videoTrack = this._localVideoTrack || localTrack
    if (!videoTrack) return
    videoTrack.getMediaStreamTrack().applyConstraints(constraints)
      .then(() => {

      })
      .catch(err => {
        this.setSolution(parseInt(videoTrack.getMediaStreamTrack().getConstraints().width / 2))
      });
  }
  async leave (closeCLoudProxy) { //手动触发离开channel
    if (!this._client) return
    return this._client.leave().then(() => {
      if (closeCLoudProxy && this._client) this._client.stopProxyServer()
      this._client = null
      this._publishAudio = false
      this._publishVideo = false
      this._hasPublishAudio = false
      this._hasPublishVideo = false
      this.hasJoined = false
      clearInterval(this.networksInterval)
      this.networksInterval = null
      if (this._localAudioTrack) {
        this._localAudioTrack.close()
        this._localAudioTrack = null
      }
      if (this._localVideoTrack) {
        this._localVideoTrack.close()
        this._localVideoTrack = null
      }
    }, (error) => {
      console.log('leave failed', error)
    })
  }
  play (track, playerConfig, info, fun) {
    if (!track) return
    const { type, videoBox } = info
    if (type === 'video') {
      if (videoBox) videoBox.innerHTML = ''
      track.play && track.play(videoBox ? videoBox : 'local_stream', playerConfig ? playerConfig : '')
      fun && fun()
    } else {
      track.play && track.play()
    }
  }
  stop (track) {
    if (!track) return
    track.stop && track.stop()
  }
  // 订阅track
  async subscribe (uid, mediaType, unExecuteCallback) {
    // mediaType : audio video all
    // uid: 需要订阅人的rtilCode
    if (!this.hasJoined || !this._client || this.connectStatus != 'CONNECTED') return
    let remoteUser = this._remotePublishUser[uid]
    if (remoteUser) {
      if (mediaType == 'audio' && remoteUser.hasAudio && this._client) {
        await this._client.subscribe(remoteUser, 'audio')
      }
      // 根据最新需求 Common party 想订阅音视频的话需要判断当前 audio-only 所选择的类型
      // 还要判断 mainWindow 和 shareScreen 是否勾选上
      if (mediaType == 'video') {
        if (this._params.executeLocalSubscribe && !unExecuteCallback && remoteUser.hasVideo) {
          this._callBack && this._callBack({
            action: 'subscribe-video',
            payload: {
              id: remoteUser.uid
            }
          })
          //koisk host页面 外部会议audioOnly特殊处理（解决shareScreen没有video问题）
          if (this._params.executeVideoAdded && remoteUser.hasVideo && this._client) {
            await this._client.subscribe(remoteUser, 'video')
          }
        } else {
          if (remoteUser.hasVideo && this._client) {
            await this._client.subscribe(remoteUser, 'video')
          }
        }
      }
      if (mediaType == 'all' && this._client) {
        if (remoteUser.hasAudio) {
          await this._client.subscribe(remoteUser, 'audio')
        }
        if (remoteUser.hasVideo) {
          await this._client.subscribe(remoteUser, 'video')
        }
      }
      let { uid, audioMuted, videoMuted, audioTrack, videoTrack } = remoteUser

      this._subscribeTrack[uid] = {
        audioTrack,
        videoTrack,
        channel: this._params.channel
      }
      this._callBack && this._callBack({
        action: 'subscribe-track',
        payload: {
          id: uid,
          audioMuted,
          videoMuted,
          audioTrack,
          videoTrack,
          channel: this._params.channel,
          type: mediaType
        }
      })
    }
  }
  // 取消订阅
  async unsubscribe (uid, mediaType) {
    if (!this.hasJoined || !this._client) return
    let remoteUser = this._remotePublishUser[uid]
    if (remoteUser) {
      if (mediaType == 'audio') {
        await this._client.unsubscribe(remoteUser, 'audio')
      }
      if (mediaType == 'video') {
        await this._client.unsubscribe(remoteUser, 'video')
      }
      if (mediaType == 'all') {
        await this._client.unsubscribe(remoteUser)
      }

      let { uid, audioTrack, videoTrack } = remoteUser

      if (!audioTrack && !videoTrack) {
        delete this._subscribeTrack[uid]
      } else {
        this._subscribeTrack[uid] = {
          audioTrack,
          videoTrack,
          channel: this._params.channel
        }
      }
      this._callBack && this._callBack({
        action: 'unsubscribe-track',
        payload: {
          id: uid,
          audioTrack,
          videoTrack,
          channel: this._params.channel,
          type: mediaType
        }
      })
    }
  }
  // 是否启用/禁用音视频轨道
  async setEnabled (status, type, fun, info = {}) {
    const { controlsMedia } = info
    let flag = true
    if (!this._client || !this.hasJoined) return
    if (type == 'video' && !this._localVideoTrack && !controlsMedia) {
      if (fun) fun('failed')
      return
    }
    if (type == 'audio' && !this._localAudioTrack && !controlsMedia) {
      if (fun) fun('failed')
      return
    }
    if (type == 'video') {
      if (this._localVideoTrack) {
        if (this._hasPublishVideo) {
          this._localVideoTrack.setEnabled(status).then(res => {
            console.info('setEnabled video', this._params.channel, status)
            $Store.state.showInitCameraTips = false
          }).catch((error) => {
            flag = false
            if (fun) fun('failed')
          })
        } else {
          // 如果因为一次没有发布过流，直接调用setEnabled无法发流
          //agora也无法推送消息。setEnabled是指在轨道已发布的情况下才起作用
          if (status) {
            this.publish(['video'])
          } else {
            await this.unpublish(['video'])
            flag = false
            // if (fun) fun('failed')
          }
        }
      } else {
        await this.createLocalVideo()
      }
    }
    if (type == 'audio') {
      if (this._localAudioTrack) {
        if (this._hasPublishAudio) {
          this._localAudioTrack.setEnabled(status).then(res => {
            console.info('setEnabled audio', this._params.channel, status)
          }).catch((error) => {
            flag = false
            if (fun) fun('failed')
          })
        } else {
          if (status) {
            console.info('setEnabled audio publish', this._params.channel, status)
            this.publish(['audio'])
          } else {
            await this.unpublish(['audio'])
            flag = false
            // if (fun) fun('failed')
          }
        }
      } else {
        await this.createLocalAudio()
      }
    }
    if (fun && flag) fun('success')
  }
  async createLocalVideo () {
    try {
      let { cameraId, videoConfig, domId, isPlay, publish, publishVideo } = this._params
      if (!videoConfig || !videoConfig.length || !this._client) return
      try {
        this._localVideoTrack = await AgoraRTC.createCameraVideoTrack({
          cameraId, //指定摄像头
          encoderConfig: {
            // 视频分辨率
            width: videoConfig[0].width,
            height: videoConfig[0].height,
            // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
            frameRate: {
              min: 15,
              max: videoConfig[0].fps
            },
            bitrateMin: videoConfig[0].bitrate,
            bitrateMax: videoConfig[0].bitrate
          }
        })
      } catch (e) {
        // 创建流失败，则就不会发流
        this._callBack && this._callBack({
          action: 'local-unpublish',
          payload: {
            id: this._params.uid,
            type: ['video']
          }
        })
        console.log('create local video failed: ', e)
      }

      this._callBack && this._callBack({
        action: 'local-track',
        payload: {
          id: this._params.uid,
          channel: this._params.channel,
          audioTrack: this._localAudioTrack,
          videoTrack: this._localVideoTrack
        }
      })
      //只播放本地视频即可，无需播放音频
      if (isPlay !== false && this._localVideoTrack) {
        if (document.getElementById(`${domId || 'local_stream'}`)) {
          this._localVideoTrack.play(`${domId || 'local_stream'}`, {
            mirror: true
          })
        } else {
          const _this = this
          if (this.playTimer) clearInterval(this.playTimer)
          this.playTimer = setInterval(() => {
            if (document.getElementById(`${domId || 'local_stream'}`)) {
              _this._localVideoTrack.play(`${domId || 'local_stream'}`, {
                mirror: true
              })
              if (this.playTimer) clearInterval(this.playTimer)
            }
          }, 100);
        }
        this.setSolution()
      }
      // 推流
      if (publish !== false) {
        // 确认需要publish的流
        let trackArray = []
        if (this._localVideoTrack) {
          trackArray.push('video')
        }
        this.publish(trackArray)
      }
    } catch (e) {
      console.info('creat track failed')
    }
  }
  async createLocalAudio () {
    try {
      let { microphoneId, videoConfig, isPlay, publish, publishAudio } = this._params
      try {
        this._localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
          AEC: true, //回声消除
          ANS: true, //噪声抑制
          microphoneId, //指定麦克风
        })
      } catch (e) {
        console.info('creat local audio error', e)
        // 创建流失败，则就不会发流
        this._callBack && this._callBack({
          action: 'local-unpublish',
          payload: {
            id: this._params.uid,
            type: ['audio']
          }
        })
      }
      this._callBack && this._callBack({
        action: 'local-track',
        payload: {
          audioTrack: this._localAudioTrack,
          videoTrack: this._localVideoTrack
        }
      })
      // 推流
      if (publish !== false) {
        // 确认需要publish的流
        let trackArray = []
        if (this._localAudioTrack) {
          trackArray.push('audio')
        }
        this.publish(trackArray)
      }
    } catch (e) {
      console.info('creat track failed')
    }
  }
  // 动态切换视频的编码参数
  setEncoderConfiguration (config) {
    if (!this._localVideoTrack || !this._localVideoTrack._enabled) return
    this._localVideoTrack.setEncoderConfiguration({
      // 视频分辨率
      width: config.width,
      height: config.height,
      // 视频编码帧率。通常建议是 15 帧，不超过 30 帧
      frameRate: config.fps,
      bitrateMin: config.bitrateRange[0],
      bitrateMax: config.bitrateRange[1]
    })
    this.setSolution()
  }
  // 获取当前通话的统计信息
  getRtcStats () {
    if (this._client) {
      let status = this._client.getRTCStats()
      return status
    }
  }
  // 创建共享屏幕的track
  async createShareTrack (status) {
    if (!this._client) return
    const { shareScreenBitrate, shareScreenFrameRate, shareScreenResolution } = status
    const setBitrate = Number(shareScreenBitrate || 2000)
    const params = shareScreenBitrate && shareScreenFrameRate && shareScreenResolution ? {
      width: Number(shareScreenResolution.split('x')[0]),
      height: Number(shareScreenResolution.split('x')[1]),
      fps: 15,  // 30 FPS 太高可能会影响自己发送端网络的稳定，因为目前代码还是会订阅自己的 sharescreen
      bitrateRange: [setBitrate - 200, setBitrate]
    } : '1080p_2'
    try {
      return AgoraRTC.createScreenVideoTrack({
        encoderConfig: params,
        // optimizationMode: 'motion'
      }, 'auto').then(async (localScreenTrack) => {
        const isArray = Array.isArray(localScreenTrack)
        this._shareTrack = localScreenTrack
        this.shareEventListener()
        await this._client?.setClientRole("host") //不需要推流的不用设置host
        this._role = 'host'
        this.hasJoined && this._client?.publish(localScreenTrack)
        this._callBack && this._callBack({
          action: 'start-share',
          payload: {
            id: this._params.uid,
            channel: this._params.channel,
            shareInfo: {
              videoTrack: isArray ? localScreenTrack[0] : localScreenTrack,
              audioTrack: isArray ? localScreenTrack[1] : null
            }
          }
        })
        return true
      }).catch((error) => {
        const { code } = error
        if (code === 'PERMISSION_DENIED' && $Store.state.isMac) {
          Bus.$emit('crateShareFailed', error)
        }
        // 错误码与消息的映射表
        const errorMessageMap = {
          NOT_SUPPORTED: 'Not supported on the current browser.',
          MEDIA_OPTION_INVALID: 'The device does not support the specified resolution or frame rate.',
          DEVICE_NOT_FOUND: 'The specified capture device cannot be found.',
          CONSTRAINT_NOT_SATISFIED: 'The browser does not support the specified capture options.',
          SHARE_AUDIO_NOT_ALLOWED: 'The user did not check the option to share audio while sharing the screen.',
          PERMISSION_DENIED: 'Create screen share permission denied.'
        }
        // 获取消息内容，未匹配时使用默认值
        const message = errorMessageMap[code] || 'Failed to create local audio and video objects.'
        // 统一显示错误消息
        Message({
          message,
          type: 'error',
          offset: 50,
          showClose: true
        })
        this._client.leave()
        this._callBack && this._callBack({
          action: 'stop-share',
          payload: {
            id: this._params.uid,
            channel: this._params.channel,
            type: 'Chrome-CreateScreenFailed'
          }
        })
      })
    } catch (e) {
      return ''
    }
  }
  Uint8ArrayToString (fileData) {
    let dataString = ''
    for (let i = 0; i < fileData.length; i++) {
      dataString += String.fromCharCode(fileData[i])
    }
    return dataString
  }
  addEventsListener () {
    let { uid, channel } = this._params //本地参数
    //加入/离开频道时，本地触发（SDK 与服务器的连接状态）
    this._client.on('connection-state-change', (curState, revState, reason) => {
      if (!this._callBack) return
      this.connectStatus = curState
      console.log('connection-state-change', curState, revState, reason)
      Bus.$emit('disconnected', curState)
      if (reason === 'UID_BANNED') {
        setTimeout(() => {
          this._callBack({
            action: 'connection-state-change',
            payload: {
              id: uid,
              channel,
              curState,
              revState,
              reason
            }
          })
        }, 5000)
      } else {
        this._callBack({
          action: 'connection-state-change',
          payload: {
            id: uid,
            channel,
            curState,
            revState,
            reason
          }
        })
      }
    })
    this._client.on('stream-message', (uid, data) => {
      const textInfo = protoRoot.Agora.SpeechToText.lookup("Text").decode(data)
      this._callBack({
        action: 'voiceCheck',
        payload: {
          id: textInfo.uid,
          textInfo: textInfo
        }
      })
    })
    //主播加入频道 推流的uid才可以被监听到
    this._client.on('user-joined', (user) => {
      let { uid, videoMuted, audioMuted } = user
      // 该回调在以下情况下会被触发：
      // 直播场景的远端观众加入频道后调用 setClientRole 将用户角色改变为主播。
      // 主播通过调用 addInjectStreamUrl 方法成功输入在线媒体流。
      this._callBack && this._callBack({
        action: 'user-joined',
        payload: {
          id: uid,
          videoMuted,
          audioMuted,
          channel
        }
      })
    })
    //远端用户离线回调 推流的uid才可以被监听到
    this._client.on('user-left', (user, reason) => {
      let { uid, videoMuted, audioMuted } = user
      console.log('user-left: ', uid, reason)
      // 正常离开：用户会收到类似“再见”的消息，接收此消息后，判断对方离开频道。
      // 超时掉线：在 20 秒内，用户没有收到对方的任何数据包，则判定为对方掉线。在网络较差的情况下，有可能会误报。
      // 用户角色从主播变为观众
      // 删除存储的所有推流的集合
      this._subscribeTrack[uid] && delete this._subscribeTrack[uid]
      this._remotePublishUser[uid] && delete this._remotePublishUser[uid]
      let action = null
      if (reason == 'Quit') { //用户调用了 leave 主动离开频道
        action = 'user-left'
      }
      if (reason == 'ServerTimeOut') { //因过长时间收不到对方数据包，超时掉线
        action = 'user-left-timeout'
      }
      if (reason == 'BecomeAudience') { //用户角色从主播切换为观众
        action = 'user-left-audience'
      }
      this._callBack && this._callBack({
        action: 'user-left',
        payload: {
          id: uid,
          videoMuted,
          audioMuted,
          channel
        }
      })
    })
    // 监听到远端用户发布了新的音频轨道或者视频轨道
    this._client.on('user-published', (remoteUser, mediaType) => {
      let { uid } = remoteUser
      this._remotePublishUser[uid] = remoteUser //存储所有发布track的远端
      const _this = this
      console.log('发流了user-published', uid, this._params.channel, mediaType)
      // 如果是自己创建的屏幕分享流也不需要订阅
      if (_this._params.subscribeRemote !== false && $Store.state.localShareInfo[uid] != this._params.uid) {
        this._client && this.subscribe(uid, mediaType);
      }
      this._callBack && this._callBack({
        action: 'user-published',
        payload: {
          id: uid,
          remoteUser,
          mediaType,
          channel,
          type: mediaType
        }
      })
    })
    // 通知远端用户取消发布了音频或视频轨道
    this._client.on('user-unpublished', (remoteUser, mediaType) => {
      let { uid } = remoteUser
      console.log('取消发流user-unpublished', uid, this._params.channel, mediaType)
      this._callBack && this._callBack({
        action: 'user-unpublished',
        payload: {
          id: uid,
          remoteUser,
          mediaType,
          channel,
          type: mediaType
        }
      })
    })
    //接收远端说话的音量
    this._client.on('volume-indicator', evt => {
      Bus.$emit('volumeList', evt);
    })
    //接收metadata
    this._client.on('receive-metadata', (uid, uint8array) => {
      let id = uid
      let info = uint8array
      this._callBack && this._callBack({
        action: "receiveMetadata",
        payload: {
          id,
          metadataInfo: info,
          channel
        }
      });
    })
    //返回本地用户的上下行网络质量
    this._client.on('network-quality', info => {
      const { downlinkNetworkQuality, uplinkNetworkQuality } = info
      Bus.$emit('downlinkNetworkQuality', downlinkNetworkQuality)
      Bus.$emit('uplinkNetworkQuality', uplinkNetworkQuality)
      //为了common party显示网络状态用
      let { channel, uid, getRemoteNetworks } = this._params
      if (getRemoteNetworks) {
        this._callBack && this._callBack({
          action: 'unlinkQuality',
          payload: {
            id: uid,
            channel,
            uplinkNetworkQuality
          }
        })
      }
    })
  }
  shareEventListener () {
    let { uid, channel } = this._params //本地参数
    // 通知远端用户取消发布了音频或视频轨道S
    // 判断当前shareTrack是对象还是数组
    if (Object.prototype.toString.call(this._shareTrack) === '[object Object]') {
      this._shareTrack.on('track-ended', (ee) => {
        this.leave()
        this._callBack && this._callBack({
          action: 'stop-share',
          payload: {
            id: uid,
            channel,
            type: 'Chrome-UserThroughBrowserControl'
          }
        })
      })
    } else {
      const _this = this
      this._shareTrack.forEach(track => {
        if (track.trackMediaType === 'video') {
          track.on('track-ended', (ee) => {
            _this.leave()
            _this._callBack({
              action: 'stop-share',
              payload: {
                id: uid,
                channel,
                type: 'Safari-UserThroughBrowserControl'
              }
            })
          })
        }
      })
    }
  }
  // 获取远端的网络状态
  getRemoteNetworksFn () {
    this.networksInterval = setInterval(() => {
      let networks = this._client ? this._client.getRemoteNetworkQuality() : ''
      if (networks) {
        Object.keys(networks).forEach(id => {
          this._callBack && this._callBack({
            action: 'unlinkQuality',
            payload: {
              id,
              channel: this._params.channel,
              uplinkNetworkQuality: networks[id].uplinkNetworkQuality,
              downlinkNetworkQuality: networks[id].downlinkNetworkQuality,
              type: 'remoteNetWorkQuality'
            }
          })
        })
      }
    }, 2000)
  }
}
/* eslint-disable no-new */ 